/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FormSubmissionDto } from '../models';
/**
 * FormSubmissionsApi - axios parameter creator
 */
export const FormSubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormSubmissionsFormIdGet: async (formId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formId' is not null or undefined
            assertParamExists('apiFormSubmissionsFormIdGet', 'formId', formId)
            const localVarPath = `/api/FormSubmissions/{formId}`
                .replace(`{${"formId"}}`, encodeURIComponent(String(formId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FormSubmissionDto} [formSubmissionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormSubmissionsPost: async (formSubmissionDto?: FormSubmissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/FormSubmissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formSubmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FormSubmissionsApi - functional programming interface
 */
export const FormSubmissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FormSubmissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} formId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormSubmissionsFormIdGet(formId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormSubmissionsFormIdGet(formId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormSubmissionsApi.apiFormSubmissionsFormIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FormSubmissionDto} [formSubmissionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFormSubmissionsPost(formSubmissionDto?: FormSubmissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormSubmissionsPost(formSubmissionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FormSubmissionsApi.apiFormSubmissionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FormSubmissionsApi - factory interface
 */
export const FormSubmissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FormSubmissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {FormSubmissionsApiApiFormSubmissionsFormIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormSubmissionsFormIdGet(requestParameters: FormSubmissionsApiApiFormSubmissionsFormIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFormSubmissionsFormIdGet(requestParameters.formId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FormSubmissionsApiApiFormSubmissionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFormSubmissionsPost(requestParameters: FormSubmissionsApiApiFormSubmissionsPostRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFormSubmissionsPost(requestParameters.formSubmissionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiFormSubmissionsFormIdGet operation in FormSubmissionsApi.
 */
export interface FormSubmissionsApiApiFormSubmissionsFormIdGetRequest {
    readonly formId: string
}

/**
 * Request parameters for apiFormSubmissionsPost operation in FormSubmissionsApi.
 */
export interface FormSubmissionsApiApiFormSubmissionsPostRequest {
    readonly formSubmissionDto?: FormSubmissionDto
}

/**
 * FormSubmissionsApi - object-oriented interface
 */
export class FormSubmissionsApi extends BaseAPI {
    /**
     * 
     * @param {FormSubmissionsApiApiFormSubmissionsFormIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiFormSubmissionsFormIdGet(requestParameters: FormSubmissionsApiApiFormSubmissionsFormIdGetRequest, options?: RawAxiosRequestConfig) {
        return FormSubmissionsApiFp(this.configuration).apiFormSubmissionsFormIdGet(requestParameters.formId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FormSubmissionsApiApiFormSubmissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiFormSubmissionsPost(requestParameters: FormSubmissionsApiApiFormSubmissionsPostRequest = {}, options?: RawAxiosRequestConfig) {
        return FormSubmissionsApiFp(this.configuration).apiFormSubmissionsPost(requestParameters.formSubmissionDto, options).then((request) => request(this.axios, this.basePath));
    }
}

